import React, { useState, useEffect, useRef } from "react";
import { Typography, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TopOfAddStepTables from "../../CellStepManagement/components/TopOfAddStepTables";
import ReusableCachePage from "../../CellStepManagement/components/ReusableCachePage";
import CachePageModal from "../../CellStepManagement/components/CachePageModal";
import PaginationBlock from "./PaginationBlock";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FilterListIcon from "@mui/icons-material/FilterList";
import Divider from "@mui/material/Divider";
import HttpService from "../../Dashboard/duck/HttpService";
import CachePageFilters from "../../ReusableCachePages/components/CachePageFilters";
import BuildPgMain from "./buildPgComps/BuildPgMain";

const StepTypeReusableCachePage = ({
  openCacheModal,
  closeCacheModal,
  cachePageModalOpen,
  onCachePageSubmit,
  id,
  studyId,
  stepType,
  data,
  loading,
  rowsPerPage,
  currentPage,
  onPageChange,
  onRowsPerPageChange,
  onSearch,
  setHasSearched,
  hasSearched,
  resetStateToLoading,
  onSelectItem,
  handleClick,
  resultCount,
  onDone,
  searchTerm,
  toggleItem,
  clearPrimarySelection,
  getStepData
}) => {
  const [showFilter, setShowFilter] = useState(false);

  const [display, setDisplay] = useState(false)

  const [pg, setPg] = useState(false)

  const changeModalView = () => {

    clearPrimarySelection()
    setDisplay(!display);

  };

  const savePg = (page) => {
    setPg(page)
  }
  const searchTimerRef = useRef(null);

  const [filters, setFilters] = useState({
    location_id: null,
    language_id: null,
    approved: true,
    order_by: "",
    filter_used_count_min: null,
    filter_used_count_max: null,
    filter_created_from: null,
    filter_created_to: null,
    filter_published_from: null,
    filter_published_to: null,
    filter_last_used_from: null,
    filter_last_used_to: null,
  });

  const [locationOptions, setLocationOptions] = useState([
    { code: null, description: "All" },
  ]);
  const [languageOptions, setLanguageOptions] = useState([
    { code: null, description: "All" },
  ]);
  const [iframeStep, setIframeStep] = useState(null)

  function updateIframeStep(newStep) {
    setIframeStep(newStep)
  }


  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const locationsRes = await HttpService.getLocationsList();
        const rawLocations = locationsRes?.data?.data || locationsRes?.data || [];

        setLocationOptions([
          { code: null, description: "All" },
          ...rawLocations.map((item) => ({
            code: item.id ?? item.code,
            description: item.description ?? item.name,
          })),
        ]);
      } catch (err) {
        console.error("Failed to fetch locations:", err);
      }
    };

    fetchFilterOptions();
  }, []);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const languagesRes = filters.location_id
          ? await HttpService.getLanguageList({ locationId: filters.location_id })
          : await HttpService.getLanguageList();

        const rawLanguages = languagesRes?.data?.data || languagesRes?.data || [];

        setLanguageOptions([
          { code: null, description: "All" },
          ...rawLanguages.map((item) => ({
            code: item.id ?? item.code,
            description: item.description ?? item.name,
          })),
        ]);
      } catch (err) {
        console.error("Failed to fetch languages:", err);
        setLanguageOptions([{ code: null, description: "All" }]);
      }
    };

    fetchLanguages();
  }, [filters.location_id]);

  const fetchReusableCachePages = (overrides = {}) => {
    const finalFilters = {
      ...filters,
      ...overrides,
    };

    const nextPageNum = overrides.pageNum !== undefined ? overrides.pageNum : 1;
    const nextSearchTerm =
      overrides.searchTerm !== undefined ? overrides.searchTerm : searchTerm || "";

    setHasSearched(true);
    resetStateToLoading();

    onPageChange?.(nextPageNum);

    onSelectItem(
      stepType,
      studyId,
      nextSearchTerm,
      rowsPerPage,
      nextPageNum,
      finalFilters.approved,
      {
        location_id: finalFilters.location_id,
        language_id: finalFilters.language_id,
        order_by: finalFilters.order_by,
        filter_used_count_min: finalFilters.filter_used_count_min,
        filter_used_count_max: finalFilters.filter_used_count_max,
        filter_created_from: finalFilters.filter_created_from,
        filter_created_to: finalFilters.filter_created_to,
        filter_published_from: finalFilters.filter_published_from,
        filter_published_to: finalFilters.filter_published_to,
        filter_last_used_from: finalFilters.filter_last_used_from,
        filter_last_used_to: finalFilters.filter_last_used_to,
      }
    );
  };

  useEffect(() => {
    return () => {
      if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    };
  }, []);

  const handleSearchChange = (val) => {
    onSearch(val);
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);

    searchTimerRef.current = setTimeout(() => {
      fetchReusableCachePages({ pageNum: 1, searchTerm: val });
    }, 400);
  };

  const handleSortChange = (orderByValue) => {
    const nextFilters = {
      ...filters,
      order_by: orderByValue,
    };

    setFilters(nextFilters);

    fetchReusableCachePages({
      order_by: orderByValue,
      pageNum: 1,
    });
  };

  return (
    <div style={{ width: "100%" }}>
      {!display ? (
        <>
          <div style={{ padding: "4px 0 12px", width: "100%" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 16,
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  minWidth: 220,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography variant="subtitle1" style={{ lineHeight: 1.2 }}>
                  Add a new cache page step
                </Typography>

                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    marginTop: 2,
                    lineHeight: 1.2,
                  }}
                >
                  A cache page step is a webpage copied and hosted by Lumen, usually
                  containing one or more ads.
                </Typography>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 0,
                  marginLeft: "auto",
                  minWidth: 0,
                  flex: 1,
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ width: "100%", maxWidth: 360, marginRight: -4 }}>
                  <TopOfAddStepTables
                    textFieldLabel="Search cache pages"
                    textFieldValue={searchTerm || ""}
                    textFieldChange={handleSearchChange}
                  />
                </div>

                <Tooltip placement="bottom" title="Cache Page Filter">
                  <IconButton
                    onClick={() => setShowFilter((p) => !p)}
                    size="small"
                    style={{
                      marginTop: 2,
                      padding: 4,
                    }}
                  >
                    <FilterListIcon
                      style={{
                        color: "rgb(99, 115, 129)",
                        marginLeft: -150,
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>

            </div>
          </div>

          <Paper
            elevation={0}
            square
            style={{
              padding: 0,
              borderRadius: 0,
              marginBottom: 24,
              background: "transparent",
            }}
          >
            {!cachePageModalOpen ? (
              <>
                <Divider
                  sx={{
                    borderColor: "rgba(0,0,0,0.08)",
                  }}
                />

                {showFilter && (
                  <div style={{ padding: "16px" }}>
                    <CachePageFilters
                      filters={filters}
                      useProvidedOptions
                      locationOptions={locationOptions}
                      languageOptions={languageOptions}
                      onChange={async (updates) => {
                        const nextFilters = {
                          ...filters,
                          ...updates,
                        };

                        if (Object.prototype.hasOwnProperty.call(updates, "location_id")) {
                          nextFilters.language_id = null;
                        }

                        setFilters(nextFilters);

                        fetchReusableCachePages({
                          ...updates,
                          ...(Object.prototype.hasOwnProperty.call(updates, "location_id")
                            ? { language_id: null }
                            : {}),
                          pageNum: 1,
                        });
                      }}
                    />
                  </div>
                )}

                {!hasSearched ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "64px 0",
                      color: "#888",
                      fontSize: "14px",
                    }}
                  >
                    <SearchIcon style={{ fontSize: 50, marginBottom: 20 }} />
                    <span>Search for a Reusable Cache Page</span>
                  </div>
                ) : (
                  <>
                    <ReusableCachePage
                      onAddAll={async (selectedIds) => {
                        for (const cacheId of selectedIds) {
                          await Promise.resolve(
                            handleClick(id, "", studyId, cacheId, { closeAfter: false })
                          );
                        }

                        onDone?.();
                      }}
                      loading={loading}
                      reusableCachePage={data}
                      handleSortChange={handleSortChange}
                      currentOrderBy={filters?.order_by || ""}
                      changeModalView={changeModalView}
                      savePg={savePg}
                    />

                    <div
                      style={{
                        position: "sticky",
                        bottom: 0,
                        zIndex: 2,
                        background: "#fff",
                        padding: "8px 0",
                        borderTop: "1px solid rgba(0,0,0,0.08)",
                      }}
                    >
                      <PaginationBlock
                        resultCount={resultCount}
                        rowsPerPage={rowsPerPage}
                        currentPage={currentPage}
                        onPageChange={onPageChange}
                        onRowsPerPageChange={onRowsPerPageChange}
                      />
                    </div>
                  </>
                )}
              </>
            ) : (
              <CachePageModal
                onCachePageSumbit={onCachePageSubmit}
                closeCacheModal={closeCacheModal}
              />
            )}
          </Paper>
        </>
      ) : (
        <BuildPgMain
          changeModalView={changeModalView}
          pg={pg}
          stepType={stepType}
          studyId={studyId}
          onSelectItem={onSelectItem}
          rowsPerPage={rowsPerPage}
          currentPage={currentPage}
          toggleItem={toggleItem}
          onSearch={onSearch}
          setHasSearched={setHasSearched}
          resetStateToLoading={resetStateToLoading}
          hasSearched={hasSearched}
          loading={loading}
          resultCount={resultCount}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          clearPrimarySelection={clearPrimarySelection}
          onAddAll={async (selectedId) => {
            const handle = await handleClick(id, "", studyId, pg.id, { closeAfter: false });

            if (!handle) {
              getStepData(studyId)
              const handle = await handleClick(id, "", studyId, pg.id, { closeAfter: false });
              return handle.data.step_id
              updateIframeStep(handle.data.step_id)
            } else {
              updateIframeStep(handle.data.step_id)
              return handle.data.step_id
            }
          }}
          cellId={id}
          iframeStep={iframeStep}
        />
      )}
    </div>
  );
};

export default StepTypeReusableCachePage;